export default __webpack_public_path__ + "static/media/facilities.65b131f0.png";